import logger from "../../../../../../utils/logger";
import { CALENDAR_BASED_LEAGUES } from "../../../constants/memberPackageConstants";

export const formatYearRange = (startYear, isCalendarBasedLeague = false) => {
  if (isCalendarBasedLeague) {
    return String(startYear);
  }
  if (typeof startYear !== "number" || isNaN(startYear)) {
    return String(startYear || "");
  }
  const endYear = startYear + 1;
  const endYearStr = String(endYear);
  // Handle century transitions properly
  const shortYear = endYearStr.length >= 2 ? endYearStr.slice(-2) : endYearStr;
  return `${startYear}-${shortYear}`;
};

export const getSeasonList = (leagueId, originalPkgSeason) => {
  try {
    let seasons = [];

    const currentDate = new Date();

    // Validate currentDate is valid
    if (isNaN(currentDate.getTime())) {
      logger.error("Invalid current date in getSeasonList");
      return [];
    }

    // Safe access to leagueId with null checks
    if (leagueId == null) {
      logger.error("Missing leagueId in getSeasonList");
      return [];
    }

    const isCalendarBasedLeague = CALENDAR_BASED_LEAGUES.includes(
      String(leagueId),
    );
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();

    // Validate year is reasonable (between 1900 and 2200)
    if (currentYear < 1900 || currentYear > 2200) {
      logger.error(`Invalid current year: ${currentYear}`);
      return [];
    }

    const seasonsAddedSet = new Set();

    if (!isCalendarBasedLeague) {
      seasonsAddedSet.add(2026);
      seasons.push({
        value: 2026,
        label: formatYearRange(2026),
      });
    }

    // Add original package season if it exists
    if (originalPkgSeason) {
      if (!seasonsAddedSet.has(originalPkgSeason)) {
        seasonsAddedSet.add(originalPkgSeason);
        seasons.push({
          value: originalPkgSeason,
          label: formatYearRange(originalPkgSeason, isCalendarBasedLeague),
        });
      }
    }

    if (isCalendarBasedLeague) {
      // Calendar-based leagues: show next year starting September 1st
      if (currentMonth >= 8) {
        // September (month 8) or later
        if (!seasonsAddedSet.has(currentYear + 1)) {
          seasonsAddedSet.add(currentYear + 1);
          seasons.push({
            value: currentYear + 1,
            label: String(currentYear + 1),
          });
        }
      } else {
        if (!seasonsAddedSet.has(currentYear)) {
          seasonsAddedSet.add(currentYear);
          seasons.push({
            value: currentYear,
            label: String(currentYear),
          });
        }
      }
    } else {
      // All other leagues (European): show next year starting March 1st
      // FIXED: Properly check for March 1st or later (month 2 is March, 0-indexed)
      if (currentMonth > 2 || (currentMonth === 2 && currentDay >= 1)) {
        if (!seasonsAddedSet.has(currentYear)) {
          seasonsAddedSet.add(currentYear);
          // March 1st or later
          seasons.push({
            value: currentYear,
            label: formatYearRange(currentYear),
          });
        }
      } else {
        // Before March 1st: show previous year season
        if (!seasonsAddedSet.has(currentYear - 1)) {
          seasonsAddedSet.add(currentYear - 1);
          seasons.push({
            value: currentYear - 1,
            label: formatYearRange(currentYear - 1),
          });
        }
      }
    }

    return seasons;
  } catch (error) {
    logger.error("Failed to get season list", error);
    return [];
  }
};
